import React, {ReactNode} from 'react';
import {Permission} from "./PermissionContext";
import usePermission from "./usePermission";

type Props = {
    to: Permission;
    enabled?: boolean
    fallback?: ReactNode
    loadingComponent?: ReactNode
    children: ReactNode
};

// This component is meant to be used everywhere a restriction based on user permission is needed
const Restricted: React.FunctionComponent<Props> = ({to, enabled, fallback,loadingComponent, children}) => {

    // We "connect" to the provider thanks to the PermissionContext
    const [loading, allowed] = usePermission(to);
    if(enabled === false){
        return <>{children}</>;
    }

    if(loading){
        return <>{loadingComponent}</>;
    }

    // If the user has that permission, render the children
    if(allowed){
        return <>{children}</>;
    }

    // Otherwise, render the fallback
    return <>{fallback}</>;
};

export default Restricted;